<template>
  <v-dialog v-model="dialogValue" max-width="1024" scrollable>
    <v-card>
      <v-card-title>
        <v-icon left>lock</v-icon>Cadastro de Usuário
        <v-spacer></v-spacer>
        <v-btn icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="usuario.nome"
          label="Nome"
          prepend-icon="person"
          type="text"
          required
          :disabled="loading"
        />
        <v-select
          prepend-icon="location_city"
          label="Cidade"
          v-model="usuario.cidade"
          :items="cidades"
          item-text="nome"
          item-value="nome"
          :disabled="loading"
        ></v-select>
        <v-text-field
          v-model="usuario.email"
          label="E-mail"
          prepend-icon="email"
          type="email"
          required
          :disabled="loading"
        />
        <v-row>
          <v-col cols="12" sm="6" md="3" v-if="userAdmin">
            <v-checkbox
              label="Ativo"
              v-model="ativo"
              :disabled="loading"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" v-if="userMaster">
            <v-checkbox
              label="Admin"
              v-model="admin"
              :disabled="loading"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="userAdmin">
          <v-col>
            <v-btn class="mx-1"  color="success" :disabled="loading" @click="salvar">
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
            <v-btn class="mx-1"  color="error" :disabled="loading" @click="excluirUsuario()" v-if="userMaster">
              <v-icon left>mdi-delete</v-icon>
              Excluir
            </v-btn>
            <v-btn class="mx-1"  color="primary" :disabled="loading" @click="alterarSenha()" v-if="userMaster">
              <v-icon left>mdi-lock</v-icon>
              Alterar senha
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
          <v-spacer v-if="!loading"></v-spacer>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <AlterarSenha
      :abrirDialog="senha"
      @dialogClose="closeAlterarSenha"
      :id="this.usuario.id"
    />
  </v-dialog>
</template>
<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import AlterarSenha from "./AlterarSenha.vue";

export default {
  data: function () {
    return {
      loading: false,
      senha: false,
      cidades: [
        { uf: "GO", nome: "Jataí" },
        { uf: "GO", nome: "Rio Verde" },
        { uf: "TO", nome: "Palmas" },
      ],
    };
  },
  components: {
    AlterarSenha,
  },
  computed: {
    ...mapGetters(["userAdmin", "userMaster"]),
    ...mapState("usuarios", ["usuario", "dialog"]),
    dialogValue: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.setDialog(val);
      },
    },
    ativo: {
      get() {
        return this.usuario.ativo;
      },
      set(val) {
        this.usuario.ativo = val;
        this.setAtivo();
      },
    },
    admin: {
      get() {
        return this.usuario.admin;
      },
      set(val) {
        this.usuario.admin = val;
        this.setAdmin();
      },
    },
  },
  methods: {
    ...mapMutations("usuarios", ["setDialog"]),
    ...mapActions("usuarios", ["hideDialog"]),
    async salvar() {
      try {
        this.loading = true;
        await this.axios.put(`/usuarios/${this.usuario.id}`, this.usuario);
        this.$store.dispatch("showSuccess", "Usuário alterado com sucesso");
        this.hideDialog();
        this.$emit("closeModal");
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    async setAtivo() {
      await this.setField("ativo", "Ativo alterado com sucesso!");
    },
    async setAdmin() {
      await this.setField("admin", "Admin alterado com sucesso!");
    },
    async setField(field, msg) {
      try {
        this.loading = true;
        const params = {};
        params[field] = this.usuario[field];
        await this.axios.put(`/usuarios/${this.usuario.id}/${field}`, params);
        this.$store.dispatch("showSuccess", msg);
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    sair() {
      this.hideDialog();
    },
    alterarSenha() {
      this.senha = true;
    },
    closeAlterarSenha() {
      this.senha = false;
    },
    async excluirUsuario() {
      try {
        this.loading = true;
        await this.axios.delete(`/usuarios/${this.usuario.id}/`);
        this.$store.dispatch("showSuccess", "Usuário excluído com sucesso!");
        this.hideDialog();
        this.$emit("closeModal");
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>